import { render, staticRenderFns } from "./GlobalNotificationsHandler.vue?vue&type=template&id=7d272d35"
import script from "./GlobalNotificationsHandler.vue?vue&type=script&lang=ts"
export * from "./GlobalNotificationsHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.9_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_p_rtqrtxx4ab5lun7j52al72xaei/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/app/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d272d35')) {
      api.createRecord('7d272d35', component.options)
    } else {
      api.reload('7d272d35', component.options)
    }
    module.hot.accept("./GlobalNotificationsHandler.vue?vue&type=template&id=7d272d35", function () {
      api.rerender('7d272d35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalNotificationsHandler.vue"
export default component.exports